export type DynamicMetadata = Record<string, number | string | boolean>;
export type ArbitraryMetadata = Record<string, number | string | boolean>;

export type TransactionOptions = {
  metadata?: ArbitraryMetadata;
  viewId?: string;
};

export type Transaction = {
  name: string;
  threshold: number;
  sentryTransaction: any;
  startTime: number;
  team: Team;
};

export enum Team {
  INTEGRATIONS = 'integrations',
  IMPACT = 'impact',
  CORE = 'core',
  APPSEC = 'appsec',
  INSIGHT = 'insight',
  ENGAGEMENT = 'engagement',
  PHOENIX = 'phoenix',
  INVENTORY = 'inventory',
  PARTNERS = 'partners',
  DEVOPS = 'devops',
  TRANSFORMATION = 'transformation',
}
